// The Early-bird deadline from its one source (DESIGN.md § 13a; Seán, 2026-10-29): the
// fullstack's public/<year>/keyDates.json "early-bird registration", which #register prices with
// and the bank invoices fall due on. Read once per visit; until it arrives (moments), Key Dates
// and the FAQ leave the Early-bird out, and nothing is priced with it.
import {ref} from "vue";
import history from "@/assets/history.json";
import {getFullstackUrl} from "@/composables/useFullstackUrl";

const SOURCE_KEY = "early-bird registration";
export const EARLY_BIRD_KEY = "early-bird registration (November)"; // this site's keyDates.json
export const earlyBirdDates = ref(null); // {dates: "November 12", datesOld: "October 30"}
let isRequested = false;

// the fullstack's own address (Vercel adds the CORS header to its static files); in development
// through this dev server's proxy (vue.config.js), as the fullstack's dev server doesn't
function getSourceUrl() {
  const path = `/${history.latestYear}/keyDates.json`;
  return process.env.NODE_ENV === "development" ? path : `${getFullstackUrl()}${path}`;
}

async function fetchEarlyBirdDates() {
  try {
    const response = await fetch(getSourceUrl());
    const item = (await response.json())?.[SOURCE_KEY];
    if (item?.dates) earlyBirdDates.value = {dates: item.dates, datesOld: item.datesOld};
  } catch {
    // the Early-bird stays out of Key Dates and the FAQ
  }
}

// the Early-bird's dates, reactive; the first call fetches them
export function getEarlyBirdDates() {
  if (!isRequested) fetchEarlyBirdDates();
  isRequested = true;
  return earlyBirdDates.value;
}

// this site's keyDates.json with the Early-bird entry's dates from the source, in its place;
// left out until they've arrived
export function withEarlyBirdDates(items) {
  if (!items?.[EARLY_BIRD_KEY]) return items;
  const source = getEarlyBirdDates();
  const entries = Object.entries(items).flatMap(([key, item]) => {
    if (key !== EARLY_BIRD_KEY) return [[key, item]];
    return source ? [[key, {...item, ...source}]] : [];
  });
  return Object.fromEntries(entries);
}
